module.exports = __webpack_public_path__ + "assets/language-squares/ja@2x-215426baed48b2a10091eb22a3c7a9e2.jpg";